
import { namespace } from 'vuex-class';
import { Vue, Component, Emit } from 'vue-property-decorator';

import { WEB_LOCALES_EMOJIS, LANG_COUNTRY_MAPPING } from '@/constants/web-locales.constant';

import type { WebLocale } from '@/enums/web-locale';

const Language = namespace('language');

@Component({ name: 'FlagSwitcher' })
export default class FlagSwitcher extends Vue {
	@Language.Getter language: string;
	@Language.State webLocale: WebLocale;
	@Language.State audioLanguage: string;

	@Emit('switcherClick')
	handleSwitcherClick() {}

	get countryFlag() {
		return WEB_LOCALES_EMOJIS?.[this.webLocale] ?? null;
	}

	get languageFlag() {
		return WEB_LOCALES_EMOJIS?.[LANG_COUNTRY_MAPPING[this.language]] ?? null;
	}

	get audioLanguageFlag() {
		return WEB_LOCALES_EMOJIS?.[LANG_COUNTRY_MAPPING[this.audioLanguage]] ?? null;
	}

	get slotData() {
		return {
			country: this.webLocale,
			countryFlag: this.countryFlag,
			language: this.language,
			languageFlag: this.languageFlag,
			audioLanguage: this.audioLanguage,
			audioLanguageFlag: this.audioLanguageFlag,
		};
	}
}
